<template>
  <div :id="`assessment-details-${assessmentId}`">
   <dash-header :pages="breadCrumbsPages" :dashboardTitle="assessmentDetail.title.rendered"  v-if="assessmentDetail.title"/>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole === 'telas_course_submitters'"/>
        <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.admin"
        v-if="userRole === 'telas_telas_administrator'"/>
        <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.assessors"
        v-else />
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }">
          <a-row>
            <a-col :span="24">
              <a-card size="small" title="Course Details">
                <a-list item-layout="horizontal" :grid="{ column: 2, gutter: 10 }" v-if="assessmentDetail.course_detail">
                  <a-list-item>
                    <a-list-item-meta
                      :description="assessmentDetail.course_detail.course_detail.title"
                    >
                      <span slot="title">Course Name:</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta
                      :description="assessmentDetail.course_detail.course_detail.institution_name"
                    >
                      <span slot="title">Institution:</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta
                      :description="assessmentDetail.course_detail.course_detail.courseLevel"
                    >
                      <span slot="title">Course Level:</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta>
                      <span slot="title">Review Status:</span>
                      <span slot="description">{{assessmentDetail.course_detail.all_meta.assessment_status[0]
                  !== 'completed' ? 'In Progress' : 'Completed'}}</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta
                      :description="assessmentDetail.course_detail.course_detail.faculty"
                    >
                      <span slot="title">Faculty/Dept:</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta
                      :description="assessmentDetail.course_detail.course_detail.studyArea"
                    >
                      <span slot="title">Course study area:</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta
                      :description="assessmentDetail.course_detail.date | formatDate"
                    >
                      <span slot="title">Assigned Date:</span>
                    </a-list-item-meta>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta>
                      <span slot="title">Assessment Start Date:</span>
                      <a-date-picker v-if="assessmentDetail.course_detail.all_meta.assessment_start_date === undefined"
                        :disabledDate="disabledDate"
                        format="DD/MM/YYYY"
                        slot="description"
                        :defaultValue="defaultAssessmentStartDate"
                        @change="assessmentStartdateChange"
                        >
                          <template slot="dateRender" slot-scope="current, today">
                            <div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
                              {{current.date()}}
                            </div>
                          </template>
                        </a-date-picker>
                        <span slot="description" v-else>{{assessmentDetail.course_detail.all_meta.assessment_start_date[0] | formatDate}}</span>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-card>
            </a-col>
          </a-row>
          <assessment-detail-edit-able
          :assessmentData="assessmentDetail.course_detail.all_meta"
          :assessmentAnswerData="assessmentDetail.course_detail.assessment_data"
          :adminAssessmnetData="userRole !== 'telas_admin_reviewers' ?  assessmentDetail.course_detail.admin_assessment_data : false"
          :isEditable="userCanEdit"
          :startDate="assessmentStartDate"
          :comments="assessmentDetail.course_detail.comment"
          :reviewLevel="assessmentDetail.course_detail.all_meta.assessment_assigned_user_level[0]"
          :previousComments="assessmentDetail.course_detail.course_detail.previous_comments"
          :key="assessmentId"
          v-if="assessmentDetail.course_detail"/>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import dashHeader from './Header.vue';
import dashSidebar from './Sidebar.vue';
import assessmentDetailEditAble from './Assessment-details-editable.vue';

export default {
  name: 'assessment-details',
  components: {
    dashSidebar,
    dashHeader,
    assessmentDetailEditAble,
  },
  data() {
    return {
      assessmentId: this.$route.params.assessmentId,
      moment,
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Assessments',
          route: '/dashboard/assessments',
        },
        {
          name: 'Assessment Details',
          route: `/assessment/${this.$route.params.assessmentId}`,
        },
      ],
      dashboardTitle: '',
      userCanEdit: false,
      assessmentStartDate: moment(new Date(), 'DD/MM/YYYY'),
    };
  },
  computed: {
    ...mapState('assessments', {
      assessmentDetail: state => state.assessmentDetail,
      defaultAssessmentStartDate: state => (state.assessmentDetail.course_detail.all_meta.assessment_start_date !== undefined ? moment(state.assessmentDetail.course_detail.all_meta.assessment_start_date[0]) : moment(new Date(), 'DD/MM/YYYY')),
    }),
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
    ...mapGetters('assessments', {
      assessmentUpdateAction: 'getAssessmentUpdateAction',
    }),
  },
  methods: {
    ...mapActions('assessments', {
      getAssessmentDetail: 'getAssessmentDetail',
    }),
    getCurrentStyle(current) {
      const style = {};
      if (current.date() === 1) {
        style.border = '1px solid #1890ff';
        style.borderRadius = '50%';
      }
      return style;
    },
    disabledDate(current) {
      return current > this.assessmentDetail.date;
    },
    checkUserCanEdit() {
      this.userCanEdit = this.userRole === 'telas_admin_reviewers'
      || this.userRole === 'telas_interim_reviewers'
      || this.userRole === 'telas_certified_reviewers';
    },
    assessmentStartdateChange(value) {
      this.assessmentStartDate = value.format();
    },
  },
  created() {
    this.getAssessmentDetail({ assessmentId: this.$route.params.assessmentId });
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'assessments/UPDATEASSESSMENT') {
        if (state.assessments.assessmentDetail.action === 'save') {
          this.$notification.success({
            message: 'Saved',
            description:
              'You have saved the asessment.',
          });
        }
        if (state.assessments.assessmentDetail.action === 'complete') {
          this.$notification.success({
            message: 'Completed',
            description:
              'You have completed the assessment.',
          });
        }
      }
      if (mutation.type === 'assessments/GETASSESSMENTDETAILBYID') {
        this.checkUserCanEdit();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
  },
};
</script>
<style >
.ant-card-extra {
  padding: 10px 0;
}
</style>
